import api from "@/api/api-config";

export async function getData() {
  return await api.get(`common`);
}
